import { render } from "./PpcBudgetAllocationWeeklyBudgetCampaign.vue?vue&type=template&id=47be4c31&scoped=true"
import script from "./PpcBudgetAllocationWeeklyBudgetCampaign.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationWeeklyBudgetCampaign.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationWeeklyBudgetCampaign.vue?vue&type=style&index=0&id=47be4c31&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47be4c31"]])

export default __exports__